import { z } from 'zod';
export var CaptchaType;
(function (CaptchaType) {
    CaptchaType["RecaptchaEnterprise"] = "RecaptchaEnterprise";
    CaptchaType["Turnstile"] = "Turnstile";
    CaptchaType["Aliyun"] = "Aliyun";
})(CaptchaType || (CaptchaType = {}));
export var AliyunCaptchaRegion;
(function (AliyunCaptchaRegion) {
    AliyunCaptchaRegion["China"] = "cn";
    AliyunCaptchaRegion["Singapore"] = "sgp";
})(AliyunCaptchaRegion || (AliyunCaptchaRegion = {}));
export var RecaptchaEnterpriseMode;
(function (RecaptchaEnterpriseMode) {
    RecaptchaEnterpriseMode["Invisible"] = "invisible";
    RecaptchaEnterpriseMode["Checkbox"] = "checkbox";
})(RecaptchaEnterpriseMode || (RecaptchaEnterpriseMode = {}));
export const turnstileConfigGuard = z.object({
    type: z.literal(CaptchaType.Turnstile),
    siteKey: z.string(),
    secretKey: z.string(),
});
export const recaptchaEnterpriseConfigGuard = z.object({
    type: z.literal(CaptchaType.RecaptchaEnterprise),
    siteKey: z.string(),
    secretKey: z.string(),
    projectId: z.string(),
    domain: z.string().optional(),
    mode: z.nativeEnum(RecaptchaEnterpriseMode).optional(),
});
export const aliyunCaptchaConfigGuard = z.object({
    type: z.literal(CaptchaType.Aliyun),
    prefix: z.string().trim().min(1),
    sceneId: z.string().trim().min(1),
    accessKeyId: z.string().trim().min(1),
    accessKeySecret: z.string().trim().min(1),
    region: z.nativeEnum(AliyunCaptchaRegion),
});
export const captchaConfigGuard = z.discriminatedUnion('type', [
    turnstileConfigGuard,
    recaptchaEnterpriseConfigGuard,
    aliyunCaptchaConfigGuard,
]);
export const captchaPublicConfigGuard = z.discriminatedUnion('type', [
    turnstileConfigGuard.pick({ type: true, siteKey: true }),
    recaptchaEnterpriseConfigGuard.pick({
        type: true,
        siteKey: true,
        domain: true,
        mode: true,
    }),
    aliyunCaptchaConfigGuard.pick({
        type: true,
        prefix: true,
        sceneId: true,
        region: true,
    }),
]);
